/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export function useDownloads() {
  const downloads = useSelector(({ downloadsState }) => downloadsState.downloads) || [];

  const attendedPastDownloads = useSelector(({ downloadsState }) => downloadsState.attendedDownloads || []);

  /**
   * Returns all flattened + sorted assets for an array of selected downloads
   */
  const getFlattenedAssets = (selectedDownloads) => {
    const assets = [];

    selectedDownloads.forEach((download) => {
      const { agenda = [], pictures = [], presentations = [], videos = [] } = download.assets || {};
      const sourceDate = new Date(download.startDateUtc).getTime();
      const { date = '' } = download.datum || {};

      const addMeta = (items, type, eventTitle) =>
        items.map((item, index) => {
          const base = {
            ...item,
            type,
            eventTitle,
            dateTime: date,
            _eventDate: sourceDate,
          };

          if (type === 'video') {
            return {
              ...base,
              eventId: download.id,
              videoIndex: index + 1, // for overlay route
              thumbnail: item.thumbnails?.[0]?.url || '',
            };
          }

          return base;
        });

      assets.push(
        ...addMeta(agenda, 'agenda', download.title),
        ...addMeta(pictures, 'picture', download.title),
        ...addMeta(presentations, 'presentation', download.title),
        ...addMeta(videos, 'video', download.title)
      );
    });

    return assets.sort((a, b) => b._eventDate - a._eventDate);
  };

  const allAssets = useMemo(() => getFlattenedAssets(downloads), [downloads]);

  return {
    downloads,
    allAssets,
    attendedPastDownloads,
    getFlattenedAssets,
  };
}
